$(document).ready(function() {
	handleEvents();

	var cookie = getCookie("IFIX_TLD");
	if (cookie != null && cookie != "") {
		redirectCookie(cookie);
	} else {
		loadPage();
	}
});

function handleEvents() {
	$('.content ul li').on('click', function() {
		var countryCode = $(this).attr("rel");
		if(countryCode == 'CL') {
			// Just track Chile clicks, but do nothing else
			ga('send','event', 'landing-mobile-com', 'choose-country', countryCode);
		}
		else {
			var linkUrl = $(this).find('> a').attr("href");
			var sessionId = $('#sessionId').val();
			if(sessionId) {
				linkUrl += '/;jsessionid=' + sessionId;
			}
			setCookieCC(countryCode);
			ga('send', {
				'hitType': 'event',
				'eventCategory': 'landing-mobile-com',
				'eventAction': 'choose-country',
				'eventLabel': countryCode,
				'hitCallback': function() {
					document.location = linkUrl;
				}
			});
		}
		return false;
	});
}

function trackPage() {
	ga('send', 'pageview');
}

function redirectCookie(site) {
    try {
    	var linkUrl = $("#url" + site).val();
		var sessionId = $('#sessionId').val();
		if(sessionId) {
			linkUrl += (sessionId)? '/;jsessionid=' + sessionId : '';
		}
		document.location = linkUrl;
    } catch (e) {
		loadPage();
    }
}

function loadPage(site) {
	$('body').css('display','block');
	trackPage();
}

function getCookie(b) {
	var c, a, e, d = document.cookie.split(";");
	for (c = 0; c < d.length; c++) {
		a = d[c].substr(0, d[c].indexOf("="));
		e = d[c].substr(d[c].indexOf("=") + 1);
		a = a.replace(/^\s+|\s+$/g, "");
		if (a == b) {
			return unescape(e)
		}
	}
}

function setCookie(c, e, a, h, d, g) {
    var b = new Date();
    b.setTime(b.getTime());
    if (a) {
        a = a * 1000 * 60 * 60 * 24
    }
    var f = new Date(b.getTime() + (a));
    document.cookie = c + "=" + escape(e) + ((a) ? ";expires=" + f.toGMTString() : "") + ((h) ? ";path=" + h : "") + ((d) ? ";domain=" + d : "") + ((g) ? ";secure" : "")
}

function setCookieCC(b) {
    try {
        setCookie("IFIX_TLD", b, 365, "/", "", "")
    } catch (a) {
        return true
    }
}